/* eslint-disable no-unused-vars */
import SizeBox from 'components/common/SizeBox';
import {
  DESKTOP_MIN_WIDTH,
  MOBILE_MIN_WIDTH,
  TABLET_MAX_WIDTH,
} from 'constants';
import { CloseBlueIcon } from 'constants/icon';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';
import FormInputCopy from '../FormInputCopy';
import FormShareVia from '../FormShareVia';

const ReferralAFiendChooseToSharePopup = ({
  isOpen,
  buttonLabel1,
  onClose,
  buttonLabel2,
  onClick,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
  content,
}) => {
  const { t } = useLang();
  const { isDesktop } = useDetectDevice();

  return (
    <>
      <style>
        {zIndexModal &&
          `
          @media screen and (max-width: ${TABLET_MAX_WIDTH - 1}px) {
            .modal {
              z-index: ${zIndexModal || '1101'};
            }
          }
        `}
        {isBackdropOverlap
          ? `
          .pickup-location-preview-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || '1100'};
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
          : `
        .pickup-location-preview-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={onClick}
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="pickup-location-preview-modal-backdrop"
        centered
      >
        <ModalTitle>
          <p>{t('label_choose_how_to_share')}</p>
          <CloseIcon src={CloseBlueIcon} onClick={onClose} />
        </ModalTitle>
        <ModalBody>
          <FormInputCopy isModal={true} value={content} />
          <SizeBox height={isDesktop ? 44 : 24} />
          <FormShareVia value={content} />
        </ModalBody>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  @media screen and (min-width: ${MOBILE_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH -
    1}px) {
    & .modal-dialog {
      position: absolute;
      margin: 0;
      top: 0px;
      height: 100dvh;
      width: 100%;
      max-width: 100%;
      align-items: end;
      transition: ease-out 0.3s !important;
      transform: none;

      & .modal-content {
        padding: 0px 16px;
        padding-bottom: 36px;
        border-radius: 0px;
        box-shadow: none;
        background: var(--ds-c-white);
        width: 100%;
        height: fit-content;
        margin-inline: auto;
        border: none;
        border-radius: 8px 8px 0 0;
      }
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    & .modal-dialog {
      transform: none;
      & .modal-content {
        padding: 40px 16px 16px 16px;
        box-shadow: var(--ds-bs-4);
        background: var(--ds-c-white);
        width: 468px;
        height: fit-content;
        margin-inline: auto;
        border: none;
        border-radius: 20px;
      }
    }
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0;
  text-align: left;
  margin-bottom: 16px;
  padding-top: 60px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-top: 20px;
    margin-bottom: 4px;
    padding-top: unset;
  }
`;

const ModalTitle = styled.div`
  position: absolute;
  top: 0px;
  width: calc(100% - 32px);
  border: none;
  padding: 0;
  display: flex;
  z-index: 1;
  border-radius: 20px 20px 0px 0px;

  & p {
    ${paragraphMixin};
    font-weight: 500;
    color: #000;
    text-transform: uppercase;
    height: 40px;
    width: calc(100% + 32px);
    margin-inline: -16px;
    margin-block: 0;
    padding: 16px;
    border-bottom: 1px solid var(--ds-c-blue-remox-light);
    background: #fff;
    display: flex;
    align-items: center;
    border-radius: 20px 20px 0px 0px;
  }
`;
const CloseIcon = styled.img`
  position: absolute;
  right: 0px;
  top: 10px;
  cursor: pointer;
  width: 20px;
  height: 20px;
`;

export default ReferralAFiendChooseToSharePopup;
